import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MenuModule } from "../menu/menu.module";
import { SharedImportsModule } from "../shared/shared-imports.module";
import { TableControlsComponent } from "../shared/table-controls/table-controls.component";
import { ErtPreplanRescueComponent } from "./ert-preplan-rescue.component";
import { NewErtPreplanRescueComponent } from "./new-ert-preplan-rescue/new-ert-preplan-rescue.component";
import { EditErtPreplanRescueComponent } from "./edit-ert-preplan-rescue/edit-ert-preplan-rescue.component";

const componentList = [
  ErtPreplanRescueComponent,
  NewErtPreplanRescueComponent,
  EditErtPreplanRescueComponent,
];

@NgModule({
  imports: [
    CommonModule,
    MenuModule,
    SharedImportsModule,
    TableControlsComponent,
    SharedImportsModule,
  ],
  declarations: [componentList],
  exports: [ErtPreplanRescueComponent],
})
export class ERTPreplanRescueModule {}
